<script setup lang="ts">
import { Portal } from '@headlessui/vue'

// The only body-portal owner in shared UI. Headless UI's Portal keeps the physical layer under
// `body` while registering nested portals with its parent Popover/Dialog focus manager. Consumers
// cannot opt out: a nested surface must prove real portal behaviour, not fall back to inline paint.
</script>

<template>
  <Portal><slot /></Portal>
</template>
